// extracted by mini-css-extract-plugin
export default {"root":"XcaDb1I7","value":"WJJwi+RN","isMultiline":"CemzNmIL","polar":"+tM28pPG"};